import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import React from "react";
import PropTypes from "prop-types";
import { gettext } from "web/script/modules/django-i18n";
import { LanguageChoicePropType } from "web/types/language";
import BurgerMenuItem from "web/react/components/burger-menu/burger-menu-item/burger-menu-item";
import BurgerMenuSecondaryHeader from "web/react/components/burger-menu/burger-menu-secondary-header/burger-menu-secondary-header";
import style from "./burger-menu-language-selector.css";

function BurgerMenuLanguageSelector(_ref) {
  var allLanguages = _ref.allLanguages,
      onBackToMainClick = _ref.onBackToMainClick;
  var currentLanguage = allLanguages.find(function (language) {
    return language.is_selected === true;
  });
  return React.createElement("div", null, React.createElement(BurgerMenuSecondaryHeader, {
    renderText: gettext("burger_menu.language_selector.title"),
    onClickEvent: onBackToMainClick
  }), React.createElement("div", {
    className: style.selectedLanguage
  }, gettext("burger_menu.language_selector", {
    language: currentLanguage.language_name
  })), React.createElement("ul", {
    id: "languageMenuLinks"
  }, allLanguages.map(function (language) {
    return React.createElement(BurgerMenuItem, {
      key: language.language_name,
      renderText: language.language_name,
      href: language.url
    });
  })));
}

export default BurgerMenuLanguageSelector;
BurgerMenuLanguageSelector.propTypes = {
  allLanguages: PropTypes.arrayOf(LanguageChoicePropType),
  onBackToMainClick: PropTypes.func.isRequired
};
BurgerMenuLanguageSelector.defaultProps = {
  allLanguages: []
};